import { getLocale } from "../runtime";

const sv_eslanguage = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Español`
};

const eslanguage = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_eslanguage(inputs)
	return "esLanguage";
};

export { eslanguage as "esLanguage" };